import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenInBrowser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 23,
	viewBox: "0 0 22 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.9498 3.35974H4.54018C2.03271 3.35974 0 5.39245 0 7.89992V17.5642C0 20.0717 2.03271 22.1044 4.54018 22.1044H14.2045C16.712 22.1044 18.7447 20.0717 18.7447 17.5642V9.1548H16.6947V17.5642C16.6947 18.9395 15.5798 20.0544 14.2045 20.0544H4.54018C3.16489 20.0544 2.05 18.9395 2.05 17.5642V7.89992C2.05 6.52463 3.16489 5.40974 4.54018 5.40974H12.9498V3.35974Z",
		fill: "#4F31FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.64777 12.0075C8.24749 12.4078 8.24749 13.0568 8.64777 13.4571C9.04806 13.8574 9.69706 13.8574 10.0973 13.4571L8.64777 12.0075ZM21.1299 2.00001C21.1299 1.43391 20.6709 0.975006 20.1049 0.975006L10.8799 0.975007C10.3138 0.975006 9.85485 1.43391 9.85485 2.00001C9.85485 2.5661 10.3138 3.02501 10.8799 3.02501H19.0799V11.225C19.0799 11.7911 19.5388 12.25 20.1049 12.25C20.6709 12.25 21.1299 11.7911 21.1299 11.225L21.1299 2.00001ZM10.0973 13.4571L20.8296 2.72479L19.3801 1.27522L8.64777 12.0075L10.0973 13.4571Z",
		fill: "#4F31FF"
	})]
});
export default SvgOpenInBrowser;
